import { Component, Input } from '@angular/core';
     
@Component({
    selector: 'app-overview-restreams-info',
    template: `
    <div   nbPopoverPlacement="bottom"  nbPopoverTrigger="hover" [nbPopover]="inf">
        <nb-icon  [options]="{'font-size': '12px'}" [icon]="'info-outline'" pack="eva" status="primary"></nb-icon>
    </div> 
    <ng-template #inf>
        <div style="padding: 10px;">
            <div>Висота : {{info.height}}</div>
            <div>Ширина : {{info.width}}</div>
            <div>Відеокодек : {{info.video_codec}}</div>
            <div>Аудіокодек : {{info.audio_codec}}</div>
            <div>FPS : {{info.fps | number:'1.0-3'}}</div>
        </div>
    </ng-template>
                 
                 `,
    styles: [` 
        nb-icon{
            font-size:12px !important;
            width:12px !important;
            height:12px !important;
        }
    `]
})
export class OverviewRestreamsInfoComponent { 
    @Input() info : any
}